import { Link } from "react-router-dom";
import firstitem from "../../assets/dummy-movie.png";
import {movieposterpath } from "../../Config/config"

function MovieComponent({
  poster,
  id,
  name,
  releaseDate
}) {
  return (
    <Link to={`/Moviedetails/${id}`} className="text-decoration-none">
      <div className='item-movie'>
        <div className='movie-img'>   
          { poster?.includes("https://m.media-amazon.com/images") &&
            <img
              src={poster}
              alt="img"
              className="w-100 imgw-100 img-fluid" 
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = firstitem;
              }} 
            />
          }

          {
            ( !(poster?.includes("https://m.media-amazon.com/images")) && 
              <img 
                src={movieposterpath + poster}
                alt="img"
                className="w-100 imgw-100 img-fluid" 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = firstitem;
                }} 
              />
            )
          }
        </div>

        <div className='movie-details'>
          <h6>{name}</h6>
          <p>
            {releaseDate && <span>{releaseDate}</span>}
            {!releaseDate && <span>Release Date</span>}
          </p>
          <p>
            {!releaseDate && <span>TBD</span>}
          </p>
        </div>
      </div>
    </Link>
  )
}

export default MovieComponent;
